module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding": "30px 0 0 0"
    },
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Who Will Bury The Dead God?")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#foreword"
    }
  }, [_vm._v("Foreword")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#prelude"
    }
  }, [_vm._v("Prelude")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#what-else-is-coming"
    }
  }, [_vm._v("1. What Else Is Coming")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#gallantry-of-madness"
    }
  }, [_vm._v("2. Gallantry of Madness")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#who-gathers-the-edge-of-truths"
    }
  }, [_vm._v("3. Who Gathers the Edge of Truths")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#elan-vital-what-keeps-me-alivesoul-or-the-last-part-of-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Elan Vital: What Keeps Me Alive—Soul or the Last Part of Me?")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#lilly-and-the-monet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Lilly and the Monet")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#how-to-philosophise-with-no-hammer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. How to Philosophise with No Hammer")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#longing-to-the-end-of-the-stage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Longing to the End of the Stage")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#madmen-of-time-beyond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Madmen of Time Beyond")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#avyakt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Avyakt")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-society",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. The Society")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#weather-sky-and-genealogy-of-the-avadhūta",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Weather, Sky, and Genealogy of the Avadhūta")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-future-of-destination",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Future of Destination")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#neighbours-knowledge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Neighbours’ Knowledge")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#by-the-traditions-of-greatness-in-history",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. By the Traditions of Greatness in History")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#the-madness-of-the-poem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. The Madness of the Poem")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#troubled-mind-and-faith-in-everything",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. Troubled Mind and Faith in ‘Everything’")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#dust-to-dust",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Dust to Dust")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#sages-of-humanity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Sages of Humanity")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#the-lost-miracle-of-philosophy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The Lost Miracle of Philosophy")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#sex-at-eventide-and-the-verse-of-the-vedas",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Sex at Eventide and the Verse of the Vedas")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#prejudice-of-artists",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Prejudice of Artists")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#when-have-you-become-paltry-or-the-philosophy-of-de-kaizen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. When Have You Become Paltry, or the Philosophy of De-Kaizen?")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#puer-aeternus-but-i-died-young",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Puer Aeternus: But I Died Young")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#who-will-bury-the-dead-god",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Who Will Bury the Dead God?")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#dark-inside-dark",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Dark Inside Dark")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#music-of-the-past",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Music of the Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#death-and-treasure-of-the-knowledge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Death and Treasure of the ‘Knowledge’")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#the-burning-firmament-and-the-free-soul",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. The Burning Firmament and the Free Soul")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#someone-digs-up-your-nihilism",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Someone Digs Up Your Nihilism")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#what-if-my-skull-was-made-of-candy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. What If My Skull Was Made of Candy?")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#searching-for-abyss-to-die",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. Searching for Abyss to Die")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#born-hard-and-die-soft",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. Born Hard and Die Soft")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#you-are-the-screaming-ocean",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. You Are the Screaming Ocean!")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#the-poems-of-dead",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. The Poems of Dead")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#non-god-avyakt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. Non-God, Avyakt")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#existential-nausea",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. Existential Nausea")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#passions-of-false-religion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Passions of False Religion")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#gyeltsen-and-his-final-solitude-for-wisdom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. Gyeltsen and His Final Solitude for Wisdom")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#epilogue-on-modern-morality-who-will-bury-the-dead-god",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Epilogue on Modern Morality: Who Will Bury the Dead God?")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0